import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, rem, Skeleton } from '@bonusly/design-system';

import { useSeasonalLogo } from '../../../../components/seasonal/use-seasonal-logo';
import logo from '../../assets/images/bonusly-logo.png';
import { useCompanyProfile } from '../../hooks/useCompanyProfile';

export const CompanyLogo: FC = () => {
	const { company, isLoading } = useCompanyProfile();
	const { t } = useTranslation('navigation');
	const { logoUrl: seasonalLogo } = useSeasonalLogo();

	// Determine which logo to use: seasonal > company > default
	const logoConfig = useMemo(() => {
		const logoSrc = seasonalLogo || company?.logo_url || logo;
		const logoAlt = seasonalLogo
			? t('links.company_logo', { name: 'Bonusly 🎃' })
			: company?.logo_url
				? t('links.company_logo', { name: company.name })
				: t('links.company_logo', { name: 'Bonusly' });

		return { logoSrc, logoAlt };
	}, [seasonalLogo, company?.logo_url, company?.name, t]);

	if (isLoading) {
		return <Skeleton borderRadius="md" data-testid="logo-loading" h={rem(40)} w={rem(120)} />;
	}

	return <Image alt={logoConfig.logoAlt} h="full" objectFit="contain" src={logoConfig.logoSrc} />;
};
